module.exports = __webpack_public_path__ + "static/media/services-bg-1.7bd973b4.avif";